import { Injectable, inject } from '@angular/core';

import { HtmlNode } from '../browser/html-node.service';
import { Page } from '../client-config/page.client-config';

@Injectable({
    providedIn: 'root',
})
export class ScrollbarEnableService {
    private readonly pageConfig = inject(Page);
    private readonly htmlNode = inject(HtmlNode);

    enable() {
        if (this.pageConfig.enableDsScrollbar) {
            this.htmlNode.setCssClass('ds-scrollbar', true);
        }
    }
}
